import { render, staticRenderFns } from "./ImportsList.vue?vue&type=template&id=ba7d10e2&scoped=true&"
import script from "./ImportsList.vue?vue&type=script&lang=js&"
export * from "./ImportsList.vue?vue&type=script&lang=js&"
import style0 from "./ImportsList.vue?vue&type=style&index=0&id=ba7d10e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7d10e2",
  null
  
)

export default component.exports